var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "flex-level fs-3" }, [
        _c("div", { staticClass: "flex-item-left" }, [
          _c("h3", [_vm._v(_vm._s(_vm.$l10n.__("Relances effectuées")))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$l10n.__(
                  "Liste des relances déjà envoyées sur ce document."
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex-item-right" },
          [
            _vm.pagination.last_page > 1
              ? _c("paginator", {
                  attrs: { pagination: _vm.pagination },
                  on: { "pagination:update": _vm.navigate }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dunning-list", { attrs: { dunnings: _vm.sentDunnings } }),
      _vm._v(" "),
      _vm.dunningState !== "completed"
        ? _c(
            "div",
            [
              _c("div", { staticClass: "flex-left fs-3" }, [
                _c("h3", [_vm._v(_vm._s(_vm.$l10n.__("Relances à venir")))]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$l10n.__(
                        "Liste des 10 prochaines relances à venir sur ce document."
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.canChaseClient
                ? _c("dunning-enable", {
                    attrs: {
                      enabled: _vm.dunningState == "enabled",
                      enableLabel: _vm.$t.__(
                        "documents.overview.tab.Dunning.activated"
                      ),
                      disableLabel: _vm.$t.__(
                        "documents.overview.tab.Dunning.disabled"
                      ),
                      description: _vm.$t.__(
                        "documents.overview.tab.Dunning.automatic_dunning"
                      )
                    },
                    on: {
                      "update:enabled": function($event) {
                        _vm.dialogVisible = true
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.plannedErrors
                ? _c(
                    "div",
                    { staticClass: "dunning-alerts" },
                    _vm._l(_vm.plannedErrors, function(msg, index) {
                      return _c("CompassAlert", {
                        key: index,
                        attrs: {
                          type: "error",
                          description: msg,
                          showClose: false
                        }
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dunningState == "enabled"
                ? _c("dunning-list", {
                    attrs: { dunnings: _vm.plannedDunnings }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            size: "small",
            title: _vm.dialogTitle
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            "before-close": _vm.closeDialog
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c("div", { staticClass: "dialog__default" }, [
              _c(
                "p",
                { staticClass: "typographies-paragraph-medium-regular" },
                [_vm._v(_vm._s(_vm.dialogMessage))]
              )
            ])
          ]),
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary"
                  },
                  on: { click: _vm.closeDialog }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "ml-3",
                  attrs: { label: _vm.dialogConfirmText, type: "primary" },
                  on: { click: _vm.toggle }
                })
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }